import styles from './App.module.css';

import Navbar from './components/Navbar/Navbar';
import HomePage from './pages/HomePage';
import ProjectPage from './pages/ProjectsPage';

import { Routes, Route, Link } from 'react-router-dom';
import React from 'react';

function App() {
    return (
        <div className={styles.App}>
            <Navbar/>
            <Routes>
                <Route path='/' element={<HomePage />} />
                <Route path='/projects' element={<ProjectPage />} />
            </Routes>
        </div>
    );
}

export default App;
